import * as React from 'react';
import { SVGProps } from 'react';

const SvgBotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1 8.245A2.71 2.71 0 0 1 9.3 5.7C9.3 4.215 10.515 3 12 3s2.7 1.215 2.7 2.7a2.71 2.71 0 0 1-1.8 2.545V10.2h5.4c1.485 0 2.7 1.215 2.7 2.7v5.4c0 1.485-1.215 2.7-2.7 2.7H5.7A2.708 2.708 0 0 1 3 18.3v-5.4c0-1.485 1.215-2.7 2.7-2.7h5.4V8.245Zm.906-1.645h-.012a.903.903 0 0 1-.894-.9c0-.495.405-.9.9-.9s.9.405.9.9a.903.903 0 0 1-.894.9Zm-.014 5.4H5.7c-.495 0-.9.405-.9.9v5.4c0 .495.405.9.9.9h12.6c.495 0 .9-.405.9-.9v-5.4c0-.495-.405-.9-.9-.9h-6.308ZM8.4 16.5a.89.89 0 0 1-.828-1.242.93.93 0 0 1 .189-.297.916.916 0 0 1 .981-.189c.108.045.207.108.297.189.081.09.144.189.189.297a.896.896 0 0 1-.189.981.89.89 0 0 1-.639.261Zm6.561-.261a.89.89 0 0 0 .639.261.89.89 0 0 0 .828-1.242.93.93 0 0 0-.189-.297l-.045-.038a.681.681 0 0 0-.252-.151.899.899 0 0 0-.981.189.93.93 0 0 0-.189.297.896.896 0 0 0 .189.981Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBotIcon;
